/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyImport } from './routes/verify'
import { Route as SignupImport } from './routes/signup'
import { Route as LoginImport } from './routes/login'
import { Route as InvitationImport } from './routes/invitation'
import { Route as FeedbackImport } from './routes/feedback'
import { Route as AccessDeniedImport } from './routes/access-denied'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppLayoutImport } from './routes/_app-layout'
import { Route as IndexImport } from './routes/index'
import { Route as StandingOfferStandingOfferIdImport } from './routes/standing-offer.$standingOfferId'
import { Route as AuthOrganizationCreateImport } from './routes/_auth.organization-create'
import { Route as AuthOrganizationImport } from './routes/_auth.organization'
import { Route as AuthInvitationsImport } from './routes/_auth.invitations'
import { Route as AuthFixedSidebarImport } from './routes/_auth._fixed-sidebar'
import { Route as AuthSubscriptionOfferSubscriptionOfferIdImport } from './routes/_auth.subscription-offer.$subscriptionOfferId'
import { Route as AuthInvitationInvitationIdImport } from './routes/_auth.invitation.$invitationId'
import { Route as AuthInternalSendUserEmailsImport } from './routes/_auth.internal.send-user-emails'
import { Route as AuthOrganizationAccessOverlaySidebarImport } from './routes/_auth._organization-access._overlay-sidebar'
import { Route as AuthFixedSidebarUserSettingsImport } from './routes/_auth._fixed-sidebar.user-settings'
import { Route as AuthFixedSidebarOrganizationAccessImport } from './routes/_auth._fixed-sidebar._organization-access'
import { Route as AppLayoutSharedSharedAppHashImport } from './routes/_app-layout.shared.$sharedAppHash'
import { Route as AppLayoutShareShareAppIdImport } from './routes/_app-layout.share.$shareAppId'
import { Route as AppLayoutPublicPublicAppHashImport } from './routes/_app-layout.public.$publicAppHash'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationSettingsImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.organization-settings'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationManagementImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.organization-management'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOnboardingImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.onboarding'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugGalleryImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.gallery'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsIndexImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.subscriptions.index'
import { Route as AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugSubscriptionSubscriptionIdImport } from './routes/_auth._organization-access._overlay-sidebar.organization.$organizationSlug.subscription.$subscriptionId'
import { Route as AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugPrivateAppSlugImport } from './routes/_auth._organization-access._overlay-sidebar.organization.$organizationSlug.private.$appSlug'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateSubscriptionOfferImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.subscriptions.create-subscription-offer'
import { Route as AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateStandingOfferImport } from './routes/_auth._fixed-sidebar._organization-access.organization.$organizationSlug.subscriptions.create-standing-offer'

// Create/Update Routes

const VerifyRoute = VerifyImport.update({
  path: '/verify',
  getParentRoute: () => rootRoute,
} as any)

const SignupRoute = SignupImport.update({
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InvitationRoute = InvitationImport.update({
  path: '/invitation',
  getParentRoute: () => rootRoute,
} as any)

const FeedbackRoute = FeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => rootRoute,
} as any)

const AccessDeniedRoute = AccessDeniedImport.update({
  path: '/access-denied',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppLayoutRoute = AppLayoutImport.update({
  id: '/_app-layout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StandingOfferStandingOfferIdRoute =
  StandingOfferStandingOfferIdImport.update({
    path: '/standing-offer/$standingOfferId',
    getParentRoute: () => rootRoute,
  } as any)

const AuthOrganizationCreateRoute = AuthOrganizationCreateImport.update({
  path: '/organization-create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOrganizationRoute = AuthOrganizationImport.update({
  path: '/organization',
  getParentRoute: () => AuthRoute,
} as any)

const AuthInvitationsRoute = AuthInvitationsImport.update({
  path: '/invitations',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFixedSidebarRoute = AuthFixedSidebarImport.update({
  id: '/_fixed-sidebar',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSubscriptionOfferSubscriptionOfferIdRoute =
  AuthSubscriptionOfferSubscriptionOfferIdImport.update({
    path: '/subscription-offer/$subscriptionOfferId',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthInvitationInvitationIdRoute = AuthInvitationInvitationIdImport.update(
  {
    path: '/invitation/$invitationId',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthInternalSendUserEmailsRoute = AuthInternalSendUserEmailsImport.update(
  {
    path: '/internal/send-user-emails',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthOrganizationAccessOverlaySidebarRoute =
  AuthOrganizationAccessOverlaySidebarImport.update({
    id: '/_organization-access/_overlay-sidebar',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthFixedSidebarUserSettingsRoute =
  AuthFixedSidebarUserSettingsImport.update({
    path: '/user-settings',
    getParentRoute: () => AuthFixedSidebarRoute,
  } as any)

const AuthFixedSidebarOrganizationAccessRoute =
  AuthFixedSidebarOrganizationAccessImport.update({
    id: '/_organization-access',
    getParentRoute: () => AuthFixedSidebarRoute,
  } as any)

const AppLayoutSharedSharedAppHashRoute =
  AppLayoutSharedSharedAppHashImport.update({
    path: '/shared/$sharedAppHash',
    getParentRoute: () => AppLayoutRoute,
  } as any)

const AppLayoutShareShareAppIdRoute = AppLayoutShareShareAppIdImport.update({
  path: '/share/$shareAppId',
  getParentRoute: () => AppLayoutRoute,
} as any)

const AppLayoutPublicPublicAppHashRoute =
  AppLayoutPublicPublicAppHashImport.update({
    path: '/public/$publicAppHash',
    getParentRoute: () => AppLayoutRoute,
  } as any)

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationSettingsRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationSettingsImport.update(
    {
      path: '/organization/$organizationSlug/organization-settings',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationManagementRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationManagementImport.update(
    {
      path: '/organization/$organizationSlug/organization-management',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOnboardingRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOnboardingImport.update(
    {
      path: '/organization/$organizationSlug/onboarding',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugGalleryRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugGalleryImport.update(
    {
      path: '/organization/$organizationSlug/gallery',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsIndexRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsIndexImport.update(
    {
      path: '/organization/$organizationSlug/subscriptions/',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

const AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugSubscriptionSubscriptionIdRoute =
  AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugSubscriptionSubscriptionIdImport.update(
    {
      path: '/organization/$organizationSlug/subscription/$subscriptionId',
      getParentRoute: () => AuthOrganizationAccessOverlaySidebarRoute,
    } as any,
  )

const AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugPrivateAppSlugRoute =
  AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugPrivateAppSlugImport.update(
    {
      path: '/organization/$organizationSlug/private/$appSlug',
      getParentRoute: () => AuthOrganizationAccessOverlaySidebarRoute,
    } as any,
  )

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateSubscriptionOfferRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateSubscriptionOfferImport.update(
    {
      path: '/organization/$organizationSlug/subscriptions/create-subscription-offer',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

const AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateStandingOfferRoute =
  AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateStandingOfferImport.update(
    {
      path: '/organization/$organizationSlug/subscriptions/create-standing-offer',
      getParentRoute: () => AuthFixedSidebarOrganizationAccessRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app-layout': {
      id: '/_app-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedImport
      parentRoute: typeof rootRoute
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackImport
      parentRoute: typeof rootRoute
    }
    '/invitation': {
      id: '/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof InvitationImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_fixed-sidebar': {
      id: '/_auth/_fixed-sidebar'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthFixedSidebarImport
      parentRoute: typeof AuthImport
    }
    '/_auth/invitations': {
      id: '/_auth/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof AuthInvitationsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/organization': {
      id: '/_auth/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthOrganizationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/organization-create': {
      id: '/_auth/organization-create'
      path: '/organization-create'
      fullPath: '/organization-create'
      preLoaderRoute: typeof AuthOrganizationCreateImport
      parentRoute: typeof AuthImport
    }
    '/standing-offer/$standingOfferId': {
      id: '/standing-offer/$standingOfferId'
      path: '/standing-offer/$standingOfferId'
      fullPath: '/standing-offer/$standingOfferId'
      preLoaderRoute: typeof StandingOfferStandingOfferIdImport
      parentRoute: typeof rootRoute
    }
    '/_app-layout/public/$publicAppHash': {
      id: '/_app-layout/public/$publicAppHash'
      path: '/public/$publicAppHash'
      fullPath: '/public/$publicAppHash'
      preLoaderRoute: typeof AppLayoutPublicPublicAppHashImport
      parentRoute: typeof AppLayoutImport
    }
    '/_app-layout/share/$shareAppId': {
      id: '/_app-layout/share/$shareAppId'
      path: '/share/$shareAppId'
      fullPath: '/share/$shareAppId'
      preLoaderRoute: typeof AppLayoutShareShareAppIdImport
      parentRoute: typeof AppLayoutImport
    }
    '/_app-layout/shared/$sharedAppHash': {
      id: '/_app-layout/shared/$sharedAppHash'
      path: '/shared/$sharedAppHash'
      fullPath: '/shared/$sharedAppHash'
      preLoaderRoute: typeof AppLayoutSharedSharedAppHashImport
      parentRoute: typeof AppLayoutImport
    }
    '/_auth/_fixed-sidebar/_organization-access': {
      id: '/_auth/_fixed-sidebar/_organization-access'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessImport
      parentRoute: typeof AuthFixedSidebarImport
    }
    '/_auth/_fixed-sidebar/user-settings': {
      id: '/_auth/_fixed-sidebar/user-settings'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof AuthFixedSidebarUserSettingsImport
      parentRoute: typeof AuthFixedSidebarImport
    }
    '/_auth/_organization-access/_overlay-sidebar': {
      id: '/_auth/_organization-access/_overlay-sidebar'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthOrganizationAccessOverlaySidebarImport
      parentRoute: typeof AuthImport
    }
    '/_auth/internal/send-user-emails': {
      id: '/_auth/internal/send-user-emails'
      path: '/internal/send-user-emails'
      fullPath: '/internal/send-user-emails'
      preLoaderRoute: typeof AuthInternalSendUserEmailsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/invitation/$invitationId': {
      id: '/_auth/invitation/$invitationId'
      path: '/invitation/$invitationId'
      fullPath: '/invitation/$invitationId'
      preLoaderRoute: typeof AuthInvitationInvitationIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/subscription-offer/$subscriptionOfferId': {
      id: '/_auth/subscription-offer/$subscriptionOfferId'
      path: '/subscription-offer/$subscriptionOfferId'
      fullPath: '/subscription-offer/$subscriptionOfferId'
      preLoaderRoute: typeof AuthSubscriptionOfferSubscriptionOfferIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/gallery': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/gallery'
      path: '/organization/$organizationSlug/gallery'
      fullPath: '/organization/$organizationSlug/gallery'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugGalleryImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/onboarding': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/onboarding'
      path: '/organization/$organizationSlug/onboarding'
      fullPath: '/organization/$organizationSlug/onboarding'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOnboardingImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-management': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-management'
      path: '/organization/$organizationSlug/organization-management'
      fullPath: '/organization/$organizationSlug/organization-management'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationManagementImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-settings': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-settings'
      path: '/organization/$organizationSlug/organization-settings'
      fullPath: '/organization/$organizationSlug/organization-settings'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationSettingsImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-standing-offer': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-standing-offer'
      path: '/organization/$organizationSlug/subscriptions/create-standing-offer'
      fullPath: '/organization/$organizationSlug/subscriptions/create-standing-offer'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateStandingOfferImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-subscription-offer': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-subscription-offer'
      path: '/organization/$organizationSlug/subscriptions/create-subscription-offer'
      fullPath: '/organization/$organizationSlug/subscriptions/create-subscription-offer'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateSubscriptionOfferImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
    '/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/private/$appSlug': {
      id: '/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/private/$appSlug'
      path: '/organization/$organizationSlug/private/$appSlug'
      fullPath: '/organization/$organizationSlug/private/$appSlug'
      preLoaderRoute: typeof AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugPrivateAppSlugImport
      parentRoute: typeof AuthOrganizationAccessOverlaySidebarImport
    }
    '/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/subscription/$subscriptionId': {
      id: '/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/subscription/$subscriptionId'
      path: '/organization/$organizationSlug/subscription/$subscriptionId'
      fullPath: '/organization/$organizationSlug/subscription/$subscriptionId'
      preLoaderRoute: typeof AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugSubscriptionSubscriptionIdImport
      parentRoute: typeof AuthOrganizationAccessOverlaySidebarImport
    }
    '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/': {
      id: '/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/'
      path: '/organization/$organizationSlug/subscriptions'
      fullPath: '/organization/$organizationSlug/subscriptions'
      preLoaderRoute: typeof AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsIndexImport
      parentRoute: typeof AuthFixedSidebarOrganizationAccessImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AppLayoutRoute: AppLayoutRoute.addChildren({
    AppLayoutPublicPublicAppHashRoute,
    AppLayoutShareShareAppIdRoute,
    AppLayoutSharedSharedAppHashRoute,
  }),
  AuthRoute: AuthRoute.addChildren({
    AuthFixedSidebarRoute: AuthFixedSidebarRoute.addChildren({
      AuthFixedSidebarOrganizationAccessRoute:
        AuthFixedSidebarOrganizationAccessRoute.addChildren({
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugGalleryRoute,
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOnboardingRoute,
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationManagementRoute,
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugOrganizationSettingsRoute,
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateStandingOfferRoute,
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsCreateSubscriptionOfferRoute,
          AuthFixedSidebarOrganizationAccessOrganizationOrganizationSlugSubscriptionsIndexRoute,
        }),
      AuthFixedSidebarUserSettingsRoute,
    }),
    AuthInvitationsRoute,
    AuthOrganizationRoute,
    AuthOrganizationCreateRoute,
    AuthOrganizationAccessOverlaySidebarRoute:
      AuthOrganizationAccessOverlaySidebarRoute.addChildren({
        AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugPrivateAppSlugRoute,
        AuthOrganizationAccessOverlaySidebarOrganizationOrganizationSlugSubscriptionSubscriptionIdRoute,
      }),
    AuthInternalSendUserEmailsRoute,
    AuthInvitationInvitationIdRoute,
    AuthSubscriptionOfferSubscriptionOfferIdRoute,
  }),
  AccessDeniedRoute,
  FeedbackRoute,
  InvitationRoute,
  LoginRoute,
  SignupRoute,
  VerifyRoute,
  StandingOfferStandingOfferIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app-layout",
        "/_auth",
        "/access-denied",
        "/feedback",
        "/invitation",
        "/login",
        "/signup",
        "/verify",
        "/standing-offer/$standingOfferId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app-layout": {
      "filePath": "_app-layout.tsx",
      "children": [
        "/_app-layout/public/$publicAppHash",
        "/_app-layout/share/$shareAppId",
        "/_app-layout/shared/$sharedAppHash"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_fixed-sidebar",
        "/_auth/invitations",
        "/_auth/organization",
        "/_auth/organization-create",
        "/_auth/_organization-access/_overlay-sidebar",
        "/_auth/internal/send-user-emails",
        "/_auth/invitation/$invitationId",
        "/_auth/subscription-offer/$subscriptionOfferId"
      ]
    },
    "/access-denied": {
      "filePath": "access-denied.tsx"
    },
    "/feedback": {
      "filePath": "feedback.tsx"
    },
    "/invitation": {
      "filePath": "invitation.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/signup": {
      "filePath": "signup.tsx"
    },
    "/verify": {
      "filePath": "verify.tsx"
    },
    "/_auth/_fixed-sidebar": {
      "filePath": "_auth._fixed-sidebar.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_fixed-sidebar/_organization-access",
        "/_auth/_fixed-sidebar/user-settings"
      ]
    },
    "/_auth/invitations": {
      "filePath": "_auth.invitations.tsx",
      "parent": "/_auth"
    },
    "/_auth/organization": {
      "filePath": "_auth.organization.tsx",
      "parent": "/_auth"
    },
    "/_auth/organization-create": {
      "filePath": "_auth.organization-create.tsx",
      "parent": "/_auth"
    },
    "/standing-offer/$standingOfferId": {
      "filePath": "standing-offer.$standingOfferId.tsx"
    },
    "/_app-layout/public/$publicAppHash": {
      "filePath": "_app-layout.public.$publicAppHash.tsx",
      "parent": "/_app-layout"
    },
    "/_app-layout/share/$shareAppId": {
      "filePath": "_app-layout.share.$shareAppId.tsx",
      "parent": "/_app-layout"
    },
    "/_app-layout/shared/$sharedAppHash": {
      "filePath": "_app-layout.shared.$sharedAppHash.tsx",
      "parent": "/_app-layout"
    },
    "/_auth/_fixed-sidebar/_organization-access": {
      "filePath": "_auth._fixed-sidebar._organization-access.tsx",
      "parent": "/_auth/_fixed-sidebar",
      "children": [
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/gallery",
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/onboarding",
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-management",
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-settings",
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-standing-offer",
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-subscription-offer",
        "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/"
      ]
    },
    "/_auth/_fixed-sidebar/user-settings": {
      "filePath": "_auth._fixed-sidebar.user-settings.tsx",
      "parent": "/_auth/_fixed-sidebar"
    },
    "/_auth/_organization-access/_overlay-sidebar": {
      "filePath": "_auth._organization-access._overlay-sidebar.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/private/$appSlug",
        "/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/subscription/$subscriptionId"
      ]
    },
    "/_auth/internal/send-user-emails": {
      "filePath": "_auth.internal.send-user-emails.tsx",
      "parent": "/_auth"
    },
    "/_auth/invitation/$invitationId": {
      "filePath": "_auth.invitation.$invitationId.tsx",
      "parent": "/_auth"
    },
    "/_auth/subscription-offer/$subscriptionOfferId": {
      "filePath": "_auth.subscription-offer.$subscriptionOfferId.tsx",
      "parent": "/_auth"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/gallery": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.gallery.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/onboarding": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.onboarding.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-management": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.organization-management.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-settings": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.organization-settings.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-standing-offer": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.subscriptions.create-standing-offer.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/create-subscription-offer": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.subscriptions.create-subscription-offer.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    },
    "/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/private/$appSlug": {
      "filePath": "_auth._organization-access._overlay-sidebar.organization.$organizationSlug.private.$appSlug.tsx",
      "parent": "/_auth/_organization-access/_overlay-sidebar"
    },
    "/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/subscription/$subscriptionId": {
      "filePath": "_auth._organization-access._overlay-sidebar.organization.$organizationSlug.subscription.$subscriptionId.tsx",
      "parent": "/_auth/_organization-access/_overlay-sidebar"
    },
    "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/subscriptions/": {
      "filePath": "_auth._fixed-sidebar._organization-access.organization.$organizationSlug.subscriptions.index.tsx",
      "parent": "/_auth/_fixed-sidebar/_organization-access"
    }
  }
}
ROUTE_MANIFEST_END */
